import { usePartnerConfig, usePartnerFeatureConfigured } from "@/partner/usePartnerConfig";
import { useAgentStore } from "@/sdk";
import { useFeatureFlag } from "@/shared-utils";

/**
 * Whether outbound calling is currently available, including the `EWP-disable-new-call-outbound`
 * kill-switch.
 *
 * Used by the redesigned voice workspace's visibility gate (via {@link useShouldShowCallControls})
 * so the leftTop panel doesn't open around an empty bar when outbound is the only reason it would
 * show. This mirrors the inline check `CallControlsManager` uses to decide whether to render the
 * idle outbound controls — keep the two in sync.
 */
export function useIsOutboundEnabled(): boolean {
    const { outboundCall } = usePartnerFeatureConfigured();
    const { technicalIssues } = usePartnerConfig();
    const agentActivity = useAgentStore((state) => state.activity);
    const { data: isNewCallOutboundDisabled = false } = useFeatureFlag("EWP-disable-new-call-outbound");

    return (
        !isNewCallOutboundDisabled &&
        Boolean(
            outboundCall || (technicalIssues?.enableOutboundCalls && agentActivity === technicalIssues.agentActivity),
        )
    );
}
